import { groq } from 'next-sanity'
import { coalesceLocaleField } from '../helpers/coalesceLocaleField'

export const createArticleTagsProjection = (localeId: string) => {
  return groq`*[
    _type == "articleTag" &&
    !(_id in path('drafts.**')) &&
    defined(path.current)
  ]{
    _id,
    ${coalesceLocaleField('title', localeId)},
    "path": path.current,
    "articlesCount": count(
      *[
        _type == "article" &&
        !(_id in path('drafts.**')) &&
        defined(path.current) &&
        references(^._id)
      ]
    )
  }[articlesCount > 0] | order(articlesCount desc, title asc){
    _id,
    title,
    path
  }`
}
